/*
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let scratchVector3 = new THREE.Vector3();
let tempCameraPos = new THREE.Vector3();

export default class Proximity extends THREE.Object3D {
  constructor(props) {
    super(props);
    this.setup(props);
  }

  setup = props => {
    this.threshold = props.threshold;
    this.distance = 4.0;
    this.previousDistance = 4.0;
    this.firstFrame = true;

    this.distanceChangedEvent = { type: 'distanceChanged', object: this };
    this.geometry = new THREE.IcosahedronBufferGeometry(0.1, 0);

    this.mesh = new THREE.Mesh(
      this.geometry,
      new THREE.MeshBasicMaterial({
        color: 0xffff00,
        opacity: props.debug ? 0.75 : 0.0,
        depthTest: false,
        depthWrite: false,
        wireframe: true,
        transparent: true,
      })
    );

    this.mesh.onBeforeRender = this.update;

    this.object = props.object;
    this.object.add(this.mesh);
  };

  update = (renderer, scene, camera, geometry, material, group) => {
    this.mesh.getWorldPosition(scratchVector3);
    camera.getWorldPosition(tempCameraPos);
    scratchVector3.sub(tempCameraPos);
    let distance = scratchVector3.length();
    this.previousDistance = this.distance;
    if (Math.abs(this.distance - distance) > 0.0001) {
      this.distance = distance;
      this.dispatchEvent(this.distanceChangedEvent);
    }

    let delta = this.distance - this.previousDistance;
    let fract = this.distance % this.threshold;
    let fractPrev = this.previousDistance % this.threshold;

    if (
      Math.abs(fractPrev - fract) >= this.threshold - Math.abs(delta) ||
      this.firstFrame
    ) {
      let status = Math.sign(delta);
      this.currentThreshold =
        Math.floor(this.previousDistance / this.threshold) * this.threshold;
      this.dispatchEvent({ type: 'thresholdExited', object: this });
      this.currentThreshold =
        Math.floor(this.distance / this.threshold) * this.threshold;
      this.dispatchEvent({ type: 'thresholdEntered', object: this });
      this.firstFrame = false;
    }
  };
}



// WEBPACK FOOTER //
// ./src/utils/Proximity.js